import React from 'react';
import { MapPin, Plus } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/Card/Card';
import { Button } from '@/components/ui/Button/Button';
import { EmptyState } from '@/components/ui/EmptyState/EmptyState';

interface EmptyDestinationsStateProps {
  onAddDestination: () => void;
}

export function EmptyDestinationsState({ onAddDestination }: EmptyDestinationsStateProps) {
  return (
    <div className="p-6">
      <div className="max-w-2xl mx-auto">
        <Card padding="lg">
          <CardContent>
            <EmptyState
              icon={<MapPin className="w-12 h-12" />}
              title="Add Your First Destination"
              description="Start by adding a destination city where you'd like to research venues. You can add as many destinations as you need."
              action={{
                label: 'Add Destination',
                onClick: onAddDestination,
              }}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

